import {ArrowRight, CheckCircle2} from "lucide-react";
import demoVideo from '../assets/dentotekDemo.mp4';

function Hero() {

    const handleRegisterClick = () => {
        window.open(process.env.REACT_APP_REGISTER_URL, '_blank');
    };

    return (
        <section className="pt-32 pb-10 lg:pt-32 lg:pb-24 px-4 bg-gradient-to-b from-blue-50/50 to-white">
            <div className="max-w-7xl mx-auto text-center lg:text-left flex flex-col lg:flex-row items-center gap-12">
                <div className="lg:w-1/2 space-y-8">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-primary rounded-full text-sm font-bold animate-bounce">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                  </span>
                        N°1 de la gestion dentaire au Maroc
                    </div>
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-[1.1]">
                        Dentotek simplifie la gestion de votre <span className="text-primary underline decoration-blue-100">cabinet dentaire</span>
                    </h1>
                    <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                        Gagnez du temps sur l'administratif, suivez vos paiements en temps réel et offrez une expérience patient exceptionnelle. Conçu avec et pour les dentistes marocains.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                        <button onClick={handleRegisterClick} className="bg-primary text-white px-8 py-4 rounded-2xl text-lg font-bold hover:bg-blue-700 transition-all shadow-xl shadow-blue-200 flex items-center justify-center gap-2">
                            Créer mon cabinet <ArrowRight size={20} />
                        </button>
                        {/*<button className="bg-white text-slate-700 border border-slate-200 px-8 py-4 rounded-2xl text-lg font-bold hover:bg-slate-50 transition-all">
                        Voir les tarifs
                    </button>*/}
                    </div>
                    <div className="flex items-center gap-6 justify-center lg:justify-start text-sm text-slate-500">
                        <div className="flex items-center gap-1"><CheckCircle2 size={16} className="text-green-500" /> Sans engagement</div>
                        <div className="flex items-center gap-1"><CheckCircle2 size={16} className="text-green-500" /> Support 24/7</div>
                    </div>
                </div>
                <div className="lg:w-1/2 relative scale-100 lg:scale-125">
                    <div className="absolute -inset-4 bg-primary/10 rounded-3xl blur-2xl -z-10 animate-pulse"></div>
                    {/*<img
                        src={dashboard}
                        alt="dashboard"
                        className="rounded-2xl shadow-2xl border border-slate-100 ring-1 ring-slate-200"
                    />*/}
                    <video
                        src={demoVideo}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="rounded-2xl shadow-2xl border border-slate-100 ring-1 ring-slate-200 w-full"
                    />
                    {/*<div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl border border-slate-100 hidden sm:flex items-center gap-3">
                    <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold">85%</div>
                    <div className="text-sm font-medium text-slate-600">Temps gagné sur la<br/>gestion des paiements</div>
                </div>*/}
                </div>
            </div>
        </section>
    );
}

export default Hero;